import { render, staticRenderFns } from "./DocProjectMaintenance.vue?vue&type=template&id=6a82672b&"
import script from "./DocProjectMaintenance.vue?vue&type=script&lang=js&"
export * from "./DocProjectMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./DocProjectMaintenance.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports